import { useNotificationStore } from '@/stores/notification';

/** Tells the user a page they tried to open is closed to them. */
export function notifyNoPermission() {
    useNotificationStore().add({
        message: 'You do not have permission to access this page.',
        color: 'error',
        timeout: 5000,
    });
}
